// Single source of truth for every Brand-search filterable attribute, consumed by both
// FiltersMenu.vue (live search page) and WatchlistCriteriaFilters.vue (watchlist criteria
// editor) — each mounts its own connectRefinementList widget per definition against its own
// instantsearch.js instance, so an attribute's config only ever needs to be authored once.
const sortByNameThenCount = ['name:asc', 'count:desc']

export const BRAND_FILTER_DEFINITIONS = [
  {
    key: 'country',
    attribute: 'country.name_en',
    widget: 'refinementList',
    icon: 'mono-globe',
    labelKey: 'Filter.country.label',
    connectorConfig: { operator: 'or', limit: 9999, sortBy: sortByNameThenCount, escapeFacetValues: true }
  },
  {
    key: 'activeSubstances',
    attribute: 'active_substances',
    widget: 'refinementList',
    icon: 'mono-flask',
    labelKey: 'Filter.activeSubstances.label',
    connectorConfig: { operator: 'or', limit: 9999, sortBy: sortByNameThenCount, escapeFacetValues: true }
  },
  {
    key: 'mahName',
    attribute: 'mah_name',
    widget: 'refinementList',
    icon: 'mono-mah',
    labelKey: 'Filter.mahName.label',
    connectorConfig: { operator: 'or', limit: 9999, sortBy: sortByNameThenCount, escapeFacetValues: true }
  },
  {
    key: 'maStatus',
    attribute: 'ma_status',
    widget: 'refinementList',
    icon: 'mono-ma-status',
    labelKey: 'Filter.maStatus.label',
    connectorConfig: { operator: 'or', limit: 9999, sortBy: sortByNameThenCount, escapeFacetValues: true }
  },
  {
    key: 'atc',
    attribute: 'atc_paths',
    widget: 'hierarchical',
    icon: 'mono-molecule',
    labelKey: 'Filter.atc.label',
    connectorConfig: { operator: 'or', limit: 10000, escapeFacetValues: true }
  },
  {
    key: 'onMarket',
    attribute: 'on_market',
    widget: 'toggle',
    icon: 'mono-market',
    labelKey: 'Filter.onMarket.label',
    connectorConfig: { operator: 'or', limit: 2 }
  },
  {
    key: 'hasIrp',
    attribute: 'has_irp',
    widget: 'toggle',
    icon: 'mono-reimbursement',
    labelKey: 'Filter.hasIrp.label',
    connectorConfig: { operator: 'or', limit: 2 }
  }
]

// The backend (saniteta-backend) runs every successful JSON response through
// TransformRequestKeys, which recursively Str::camel()s every key — including inside the
// opaque `watchlists.filters` JSON blob. Str::camel() replaces '-'/'_' with spaces, capitalizes
// each word, and leaves '.' untouched, so a dotted key like 'country.name_en' comes back as
// 'country.nameEn', not a simple camelCase of the whole string. Requests going the other way
// are snake_cased, so already-canonical keys round-trip untouched on write — only reading a
// previously-saved `filters` object needs this reverse map (kept as a hardcoded, finite lookup
// rather than a generic un-camelCase algorithm, since e.g. 'isoAlpha2' can't be reversed
// unambiguously).
export const CANONICAL_TO_RESPONSE_KEY = {
  'active_substances': 'activeSubstances',
  'atc_code': 'atcCode',
  'atc_paths': 'atcPaths',
  'mah_name': 'mahName',
  'ma_status': 'maStatus',
  'on_market': 'onMarket',
  'has_irp': 'hasIrp',
  'country_id': 'countryId',
  'country.name_en': 'country.nameEn',
  'country.iso_alpha_2': 'country.isoAlpha2',
  'query': 'query'
}

export const RESPONSE_KEY_TO_CANONICAL = Object.fromEntries(
  Object.entries(CANONICAL_TO_RESPONSE_KEY).map(([canonical, response]) => [response, canonical])
)
